import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'duration',
    standalone: false
})
export class DurationPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return '';

    // Handle ISO 8601 duration format: PT13H20M, PT4H5M, PT2H, PT45M, etc.
    const match = value.match(/^PT(?:(\d+)H)?(?:(\d+)M)?$/);
    if (!match) return value;

    const hours = match[1] ? parseInt(match[1], 10) : 0;
    const minutes = match[2] ? parseInt(match[2], 10) : 0;

    if (hours && minutes) {
      return `${hours}h ${minutes}m`;
    } else if (hours) {
      return `${hours}h`;
    } else if (minutes) {
      return `${minutes}m`;
    }
    return value;
  }

}
